<template>
  <div class="short-deck-hand-range panel panel-default">
    <hand-range-header
      v-bind:generalHands="generalHands"
      v-bind:weightToApplyToAddedHands="weightToApplyToAddedHands"
      v-bind:combosToAdd="combosToAdd"
      v-bind:canBeRemoved="canBeRemoved"
      v-bind:specificHandsNotAllowed="specificHandsNotAllowed"
      v-bind:disabled="disableAllSelectors"
      v-on:removePlayer="$emit('removePlayer')"
      v-on:clearRange="emitAndResetDoubleSlider('clearRange')"
      v-on:addComboToCombosToAdd="$emit('addComboToCombosToAdd', $event)"
      v-on:removeComboFromCombosToAdd="$emit('removeComboFromCombosToAdd', $event)"
      v-on:applyExactWeightToGeneralHands="emitAndResetDoubleSlider('applyExactWeightToGeneralHands', $event)"
      v-on:setWeightToApplyToAddedHands="$emit('setWeightToApplyToAddedHands', $event)"
    >
      <slot name="left-header" slot="left-header"></slot>
      <slot name="extra-dropdown-item-1" slot="extra-dropdown-item-1"></slot>
    </hand-range-header>
    <div class="panel-body">
      <section class="left-or-top">
        <short-deck-grid-selector
          v-bind:generalHands="generalHands"
          v-bind:disabled="disableAllSelectors"
          v-bind:specificHandsNotAllowed="specificHandsNotAllowed"
          v-on:selectGeneralHand="emitAndResetDoubleSlider('selectGeneralHand', $event)"
          v-on:deselectGeneralHand="emitAndResetDoubleSlider('deselectGeneralHand', $event)"
          v-on:selectGeneralHands="emitAndResetDoubleSlider('selectGeneralHands', $event)"
          v-on:deselectGeneralHands="emitAndResetDoubleSlider('deselectGeneralHands', $event)"
          v-on:selectSpecificHand="emitAndResetDoubleSlider('selectSpecificHand', $event)"
          v-on:deselectSpecificHand="emitAndResetDoubleSlider('deselectSpecificHand', $event)"
          v-on:setSpecificHandAsManuallySet="emitAndResetDoubleSlider('setSpecificHandAsManuallySet', $event)"
          v-on:setSpecificHandAsNotManuallySet="emitAndResetDoubleSlider('setSpecificHandAsNotManuallySet', $event)"
          v-on:applyExactWeightToGeneralHand="emitAndResetDoubleSlider('applyExactWeightToGeneralHand', $event)"
          v-on:setWeightOfSpecificHand="emitAndResetDoubleSlider('setWeightOfSpecificHand', $event)"
          v-on:finishedClickAndDrag="$emit('finishedClickAndDrag')"
        />
        <slider-selector
          ref="sliderSelector"
          v-bind:percentOfHandsInRangeNumberForDisplay="generalHands.percentOfHandsInRangeNumberForDisplay"
          v-bind:numberOfSpecificHandsInRange="generalHands.numberOfSpecificHandsInRange.roundToTwoDecimalPlaces()"
          v-bind:numberOfPossibleSpecificHands="generalHands.numberOfPossibleSpecificHands.roundToTwoDecimalPlaces()"
          v-bind:disabled="disableAllButGridSelector || disableAllSelectors"
          v-on:setRangeToMatchDoubleSlider="$emit('setRangeToMatchDoubleSlider', $event)"
        />
        <horizontal-set-weight-to-apply-to-added-hands-basic
          v-if="settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic' || settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings'"
          ref="horizontalSetWeightToApplyToAddedHandsSlider"
          v-bind:weightToApplyToAddedHands="weightToApplyToAddedHands"
          v-bind:disabled="disableAllSelectors"
          v-bind:shortDeck="true"
          v-on:setWeightToApplyToAddedHands="$emit('setWeightToApplyToAddedHands', $event)"
        />
        <text-selector
          v-bind:generalHands="generalHands"
          v-bind:disabled="disableAllButGridSelector || disableAllSelectors"
          v-on:setRangeToMatchSpecificHandStrings="emitAndResetDoubleSlider('setRangeToMatchSpecificHandStrings', $event)"
        />
      </section>
      <vertical-set-weight-to-apply-to-added-hands
        v-if="settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic' || settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings'"
        ref="verticalSetWeightToApplyToAddedHandsSlider"
        v-bind:weightToApplyToAddedHands="weightToApplyToAddedHands"
        v-bind:disabled="disableAllSelectors"
        v-bind:shortDeck="true"
        v-on:setWeightToApplyToAddedHands="$emit('setWeightToApplyToAddedHands', $event)"
      />
      <section class="right-or-bottom">
        <ul class="nav nav-tabs">
          <li v-bind:class="{ 'active': activeTab === 'saved-ranges' }">
            <a v-on:click="activeTab = 'saved-ranges'">Saved ranges</a>
          </li>
          <li v-bind:class="{ 'active': activeTab === 'tiers' }">
            <a v-on:click="activeTab = 'tiers'">Tiers</a>
          </li>
          <li v-bind:class="{ 'active': activeTab === 'categories' }">
            <a v-on:click="activeTab = 'categories'">Categories</a>
          </li>
        </ul>
        <div class="tab-content">
          <div v-bind:class="{ 'active': activeTab === 'saved-ranges', 'tab-pane': true }" v-if="activeTab === 'saved-ranges'">
            <saved-ranges-selector
              v-bind:disabled="disableAllButGridSelector || disableAllSelectors"
              v-bind:generalHands="generalHands"
              v-on:setRangeToMatchGeneralHands="emitAndResetDoubleSlider('setRangeToMatchGeneralHands', $event)"
            />
          </div>
          <div v-bind:class="{ 'active': activeTab === 'tiers', 'tab-pane': true }" v-if="activeTab === 'tiers'">
            <tier-selector
              v-bind:disabled="disableAllButGridSelector || disableAllSelectors"
              v-bind:generalHands="generalHands"
              v-on:selectGeneralHands="emitAndResetDoubleSlider('selectGeneralHands', $event)"
              v-on:deselectGeneralHands="emitAndResetDoubleSlider('deselectGeneralHands', $event)"
            />
          </div>
          <div v-bind:class="{ 'active': activeTab === 'categories', 'tab-pane': true }" v-if="activeTab === 'categories'">
            <category-selector
              v-bind:disabled="disableAllButGridSelector || disableAllSelectors"
              v-bind:generalHands="generalHands"
              v-bind:shortDeck="true"
              v-on:selectGeneralHands="emitAndResetDoubleSlider('selectGeneralHands', $event)"
              v-on:deselectGeneralHands="emitAndResetDoubleSlider('deselectGeneralHands', $event)"
            />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import HandRangeHeader from '@/components/hand-range/header';
import ShortDeckGridSelector from '@/components/short-deck/short-deck-grid-selector';
import SliderSelector from '@/components/hand-range/slider-selector/slider-selector';
import TextSelector from '@/components/hand-range/text-selector/text-selector';
import VerticalSetWeightToApplyToAddedHands from '@/components/hand-range/hand-weight/vertical-set-weight-to-apply-to-added-hands/vertical-set-weight-to-apply-to-added-hands';
import HorizontalSetWeightToApplyToAddedHandsBasic from '@/components/hand-range/hand-weight/horizontal-set-weight-to-apply-to-added-hands-basic';
import TierSelector from '@/components/hand-range/tier-selector';
import CategorySelector from '@/components/hand-range/category-selector';
import SavedRangesSelector from '@/components/hand-range/saved-ranges-selector';

export default {
  name: 'short-deck-hand-range',
  components: {
    'hand-range-header': HandRangeHeader,
    'short-deck-grid-selector': ShortDeckGridSelector,
    'slider-selector': SliderSelector,
    'text-selector': TextSelector,
    'vertical-set-weight-to-apply-to-added-hands': VerticalSetWeightToApplyToAddedHands,
    'horizontal-set-weight-to-apply-to-added-hands-basic': HorizontalSetWeightToApplyToAddedHandsBasic,
    'tier-selector': TierSelector,
    'category-selector': CategorySelector,
    'saved-ranges-selector': SavedRangesSelector,
  },
  props: ['generalHands', 'weightToApplyToAddedHands', 'combosToAdd', 'disableAllSelectors', 'disableAllButGridSelector', 'canBeRemoved', 'specificHandsNotAllowed'],
  data: function () {
    return {
      activeTab: 'saved-ranges', // or 'tiers', or 'categories'
    };
  },
  computed: {
    includedSelectors: function () {
      return this.$store.state.account.user.settings.general.includedSelectors;
    },
    settingHandWeightsSetting: function () {
      return this.$store.state.account.user.settings.general.visual.settingHandWeights;
    },
  },
  mounted: function () {
    this.refreshDoubleSlider();
    this.refreshVerticalSetWeightToApplyToAddedHandsSlider();
    this.refreshHorizontalSetWeightToApplyToAddedHandsSlider();
  },
  updated: function () {
    this.refreshDoubleSlider();
    this.refreshVerticalSetWeightToApplyToAddedHandsSlider();
    this.refreshHorizontalSetWeightToApplyToAddedHandsSlider();
  },
  methods: {
    emitAndResetDoubleSlider: function (eventName, arg1) {
      this.$emit(eventName, arg1);
      this.resetDoubleSlider();
    },
    resetDoubleSlider: function () {
      this.$refs.sliderSelector.resetDoubleSlider();
    },
    refreshDoubleSlider: function () {
      this.$refs.sliderSelector.refreshDoubleSlider();
    },
    refreshVerticalSetWeightToApplyToAddedHandsSlider: function () {
      if (this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic' || this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings') {
        this.$refs.verticalSetWeightToApplyToAddedHandsSlider.refreshVueSlider();
      }
    },
    refreshHorizontalSetWeightToApplyToAddedHandsSlider: function () {
      if (this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic' || this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings') {
        this.$refs.horizontalSetWeightToApplyToAddedHandsSlider.refreshVueSlider();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .panel {
    overflow-x: scroll;
  }

  .panel-body {
    white-space: nowrap;
  }

  section.left-or-top, section.right-or-bottom {
    display: inline-block;
  }

  section.left-or-top {
    max-width: 350px;
    margin-right: 10px;
  }

  section.right-or-bottom {
    vertical-align: top;
    width: 260px;
    height: 270px;

    .nav-tabs a {
      cursor: pointer;
    }

    .tab-pane {
      margin-top: 10px;
    }
  }

  @media (max-width: 672px) {
    section.right-or-bottom {
      height: 350px;
      width: 100%;
      max-width: 350px;
    }

    .panel-body {
      white-space: normal;
    }

    .right-or-bottom {
      margin-top: 20px;
    }
  }

  @media (max-width: 470px) {
    .short-deck-hand-range {
      .vertical-set-weight-to-apply-to-added-hands /deep/ .vertical-set-weight-to-apply-to-added-hands-basic, .vertical-set-weight-to-apply-to-added-hands /deep/ .vertical-set-weight-to-apply-to-added-hands-with-settings-container {
        display: none;
      }

      .horizontal-set-weight-to-apply-to-added-hands-basic {
        display: inline-block;
        margin-top: 15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/short-deck/short-deck-hand-range.vue